import OwnerSubHeader from "@/components/OwnerSubHeader";
import Assets from "@/pages/Assets";

export default function AssetsPage() {
  return (
    <div className="space-y-5" data-testid="owner-assets-page">
      <OwnerSubHeader title="Manage Assets" subtitle="Fleet · types · models" />
      <Assets />
    </div>
  );
}
